import {Component} from '@angular/core';


@Component({
  selector: 'app-not-found-recource',
  templateUrl: './not-found-recourse.component.html',
  styleUrls: ['./not-found-recourse.component.scss']
})
export class NotFoundRecourseComponent {

}
